import { render, staticRenderFns } from "./payData.vue?vue&type=template&id=9999bb52&scoped=true"
import script from "./payData.vue?vue&type=script&lang=js"
export * from "./payData.vue?vue&type=script&lang=js"
import style0 from "./payData.vue?vue&type=style&index=0&id=9999bb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9999bb52",
  null
  
)

export default component.exports